import { ref, type Ref } from 'vue';

// TYPES
import type { CurrencyWalletType } from '@/types/CurrencyWalletType';

export function useCreateWalletFlow() {
  const isStablecoinDrawerOpen = ref(false);
  const selectedCurrency: Ref<CurrencyWalletType | null> = ref(null);

  function handleStablecoinSelected(currency: CurrencyWalletType) {
    selectedCurrency.value = currency;
    isStablecoinDrawerOpen.value = true;
  }

  function closeStablecoinDrawer() {
    isStablecoinDrawerOpen.value = false;
    selectedCurrency.value = null;
  }

  return {
    isStablecoinDrawerOpen,
    selectedCurrency,
    handleStablecoinSelected,
    closeStablecoinDrawer,
  };
}
